export const showSummaryExtraInfo = (months, fee) => {
  if (!fee) return false;
  return months >= 2 && parseFloat(fee.replace(/[^0-9]/g, '')) > 0;
};

export const showFeeDiscountInfo = (price) =>
  price?.fee && price?.netFee && price.fee !== price.netFee;
